export const JOIN_USER_EVENTS_ROOM = 'JOIN_USER_EVENTS_ROOM';

export const JOIN_NOTIFICATIONS_ROOM = 'JOIN_NOTIFICATIONS_ROOM';
export const LEAVE_NOTIFICATIONS_ROOM = 'LEAVE_NOTIFICATIONS_ROOM';
export const ON_NOTIFICATIONS = 'ON_NOTIFICATIONS';

export const JOIN_MARKETS_TRADES_ROOM = 'JOIN_MARKETS_TRADES_ROOM';
export const LEAVE_MARKETS_TRADES_ROOM = 'LEAVE_MARKETS_TRADES_ROOM';
export const ON_MARKETS_TRADES = 'ON_MARKETS_TRADES';

export const JOIN_COMMON_MARKETS_ROOM = 'JOIN_COMMON_MARKETS_ROOM';
export const LEAVE_COMMON_MARKETS_ROOM = 'LEAVE_COMMON_MARKETS_ROOM';
export const ON_MARKETS_CHANGE = 'ON_MARKETS_CHANGE';

export const JOIN_EVENT_LOBBIES_ROOM = 'JOIN_EVENT_LOBBIES_ROOM';
export const LEAVE_EVENT_LOBBIES_ROOM = 'LEAVE_EVENT_LOBBIES_ROOM';
export const ON_EVENT_LOBBIES = 'ON_EVENT_LOBBIES';

export const JOIN_MATCHES_ROOM = 'JOIN_MATCHES_ROOM';
export const LEAVE_MATCHES_ROOM = 'LEAVE_MATCHES_ROOM';
export const ON_MATCHES_CHANGE = 'ON_MATCHES_CHANGE';

export const JOIN_COMMON_UPDATES_ROOM = 'JOIN_COMMON_UPDATES_ROOM';
export const LEAVE_COMMON_UPDATES_ROOM = 'LEAVE_COMMON_UPDATES_ROOM';
export const ON_COMMON_UPDATES = 'ON_COMMON_UPDATES';

// tags for ON_MARKETS_CHANGE event
export const TRADE_CREATED = 'trade::created';
export const MARKET_UPDATED = 'market::updated';
export const MARKET_BULK_UPDATED = 'market::bulk-updated';
export const MARKET_BULK_CREATED = 'market::bulk-created';
export const MARKET_CREATED = 'market::created';
export const MARKET_DELETED = 'market::deleted';
export const USER_SCORE_UPDATED = 'user_score::updated';
export const MATCH_UPDATED = 'match::updated';
export const MATCH_RESULT_UPDATED = 'match::result-updated';
export const SLATE_SCOPE_UPDATED = 'slate::scope-updated';
export const TRADE_EXPORTED = 'trade::exported';

export const JOIN_CHAT_ROOM = 'JOIN_CHAT_ROOM';
export const LEAVE_CHAT_ROOM = 'LEAVE_CHAT_ROOM';
export const ON_CHAT = 'ON_CHAT';

export const JOIN_MATCHMAKING_ROOM = 'JOIN_MATCHMAKING_ROOM';
export const LEAVE_MATCHMAKING_ROOM = 'LEAVE_MATCHMAKING_ROOM';
export const ON_MATCHMAKING = 'ON_MATCHMAKING';

export const ON_REVIVAL_SUGGESTION = 'ON_REVIVAL_SUGGESTION';
export const ON_SECOND_CHANCE_RANK_UPDATED = 'ON_SECOND_CHANCE_RANK_UPDATED';

export const JOIN_PROBABILITY_LEADERBOARD_ROOM = 'JOIN_PROBABILITY_LEADERBOARD_ROOM';
export const LEAVE_PROBABILITY_LEADERBOARD_ROOM = 'LEAVE_PROBABILITY_LEADERBOARD_ROOM';
export const ON_PROBABILITY_LEADERBOARD = 'ON_PROBABILITY_LEADERBOARD';

export const ON_USER_DATA_EXPORT = 'ON_USER_DATA_EXPORT';
